import { makeClassName } from '@siteless/util';

const ChevronRightIcon = ({
  className,
  ...rest
}: {
  className?: string;
  [x: string]: any;
}) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
    className={makeClassName('feather feather-chevron-right', className)}
    {...rest}
  >
    <polyline points="9 18 15 12 9 6" fill="none" />
  </svg>
);

export default ChevronRightIcon;
